export default {
  SET_VENTURE(state, venture) {
    state.venture = venture;
  },
};
